import { render } from "./WideNav.vue?vue&type=template&id=47afc00e"
import script from "./WideNav.vue?vue&type=script&lang=js"
export * from "./WideNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__